/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Tool, Tool$inboundSchema } from "./tool.js";

export type ListToolsResult = {
  /**
   * The cursor to fetch results from
   */
  nextCursor?: string | undefined;
  /**
   * The list of tools (polymorphic union of HTTP tools and prompt templates)
   */
  tools: Array<Tool>;
};

/** @internal */
export const ListToolsResult$inboundSchema: z.ZodMiniType<
  ListToolsResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    tools: z.array(Tool$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listToolsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListToolsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListToolsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListToolsResult' from JSON`,
  );
}
